interface AuthLike {
  readonly currentUser: unknown
  authStateReady(): Promise<void>
}

// Idempotent anonymous sign-in. Parallel callers share one in-flight promise
// instead of minting duplicate anon users. It waits for the persisted session to
// restore first: AuthProvider's boot timeout can report "no user" before it
// does, and signing in anonymously then would replace the real account.
export function createEnsureAnonAuth(auth: AuthLike, signInAnonymously: () => Promise<unknown>) {
  let pending: Promise<void> | null = null
  return function ensureAnonAuth(): Promise<void> {
    if (auth.currentUser) return Promise.resolve()
    if (pending) return pending
    pending = auth
      .authStateReady()
      .then(async () => {
        if (!auth.currentUser) await signInAnonymously()
      })
      .finally(() => {
        pending = null
      })
    return pending
  }
}
